import { FC } from "react";
import { InputNumber, Slider } from "antd";
import { useTranslation } from "react-i18next";
import { DiscountItemType } from "src/Modules/Discounts/types";
import { formatNumber } from "src/utility";

type Props = {
  item: DiscountItemType;
  rangeValue: number;
  onRangeChange: (value: number) => void;
};

const GiftcardRangeSelector: FC<Props> = ({ item, rangeValue, onRangeChange }) => {
  const { t } = useTranslation();
  const currency = item.currency ?? t("Giftcards.currencyFallback");
  const min = Number(item.from ?? 0);
  const max = Number(item.to ?? 0);

  return (
    <div className="flex flex-col gap-3">
      <span className="text-sm font-medium text-font-default">{t("Giftcards.enterAValue")}</span>
      <InputNumber
        min={min}
        max={max}
        value={rangeValue}
        onChange={(v) => v != null && onRangeChange(v)}
        className="w-full! rounded-md! text-lg!"
        suffix={<span className="text-xs text-font-subtle">{currency}</span>}
        formatter={(value) => String(formatNumber(Number(value)) ?? 0)}
        controls={false}
        size="large"
      />
      <div className="flex flex-col gap-1">
        <Slider
          min={min}
          max={max}
          value={rangeValue}
          onChange={onRangeChange}
          className="m-0!"
          classNames={{ track: "bg-background-primary!" }}
          tooltip={{ formatter: (v) => `${formatNumber(v ?? 0)} ${currency}` }}
        />
        <div className="flex items-center justify-between text-xs text-font-subtle">
          <span>{t("Giftcards.minValue", { value: `${formatNumber(min)} ${currency}` })}</span>
          <span>{t("Giftcards.maxValue", { value: `${formatNumber(max)} ${currency}` })}</span>
        </div>
      </div>
    </div>
  );
};

export default GiftcardRangeSelector;
